import { Localization } from "@viamap/viamap2-common"
import { CustomLayerAutoComplete, FavoriteLayerAutoComplete, FeatureLayerAutoComplete } from "src/managers/SearchBarGeneralPlugin"
import { SearchBarGeneral } from "./SearchBarGeneral"
import { CustomGroup } from "./GroupedLayerControl"
import { autoUpdate, FloatingPortal, useFloating } from "@floating-ui/react"
import { ActionTracker } from "src/common/managers/ActionTracker"

export function GroupedLayerSearch(props: {
   open: boolean,
   customFeatureLayers: any[],
   onCustomFeatureLayerToggle: (selected: any) => void,
   callBackOnSelectFeatureLayer: (title: string, show: boolean, layers: { key: string, layer?: any }[], isGroup?: boolean) => void,
   featureLayers: { [key: string]: any },
   selectedFeatureLayerKeys: string[],
   myCustomGroups: CustomGroup[]
}) {

   const { refs, floatingStyles } = useFloating({
      placement: "bottom-start",
      whileElementsMounted: autoUpdate
   });

   if (!props.open) {
      return null;
   }


   return (
      <>
         <SearchBarGeneral
            showWindow={true}
            customPopup={(props) => (
               <>
                  <div ref={refs.setReference} className="general-autocomplete-suggestion-floating-ref"></div>
                  <FloatingPortal>
                     <div ref={refs.setFloating} className="general-autocomplete-suggestion-floating" style={floatingStyles} >
                        <div className="general-autocomplete-suggestion-scrollpane">
                           {props.children}
                        </div>
                     </div>
                  </FloatingPortal>
               </>
            )}
            autocompleters={[
               new CustomLayerAutoComplete(props.customFeatureLayers, (selected) => {
                  ActionTracker.track("GroupedLayerSearch", "Search", "Custom");
                  props.onCustomFeatureLayerToggle(selected)
               }),
               new FavoriteLayerAutoComplete(props.myCustomGroups, (selected) => {
                  ActionTracker.track("GroupedLayerSearch", "Search", "FavoriteGroup");
                  let layersInGroup = selected.layers.filter((a) => selected.layerSpecs || props.featureLayers[a])
                  let activeInGroup = layersInGroup.filter((a) => props.selectedFeatureLayerKeys.includes(a))

                  function toggleGroup() {
                     if (activeInGroup.length) {
                        props.callBackOnSelectFeatureLayer(selected.title,
                           false, selected.layers.map((a) => ({ key: a })), true
                        )
                     } else {
                        props.callBackOnSelectFeatureLayer(selected.title,
                           true, selected.layers.map((a) => ({ key: a, layer: selected.layerSpecs?.[a] })), true
                        )
                     }
                  }
                  toggleGroup()
               }),
               new FeatureLayerAutoComplete(Object.values(props.featureLayers), props.selectedFeatureLayerKeys, (selected) => {
                  ActionTracker.track("GroupedLayerSearch", "Search", "FeatureLayer");
                  const show = !props.selectedFeatureLayerKeys.includes(selected.layer.label)
                  const title = selected.layer.translationTable?.[Localization.getLanguage()]?.[selected.layer.label] || selected.layer.label
                  props.callBackOnSelectFeatureLayer(title, show, [{ key: selected.layer.label, layer: selected }], true)
                  if (show) {
                     //   addRecentLayer(selected.layer.label,selected);
                  }
               })
            ]}
            callbackOnSelection={(type: string, props: any) => { alert(`got callback Type:${type} props: ${JSON.stringify(props)}`) }}
         />
      </>
   )

}